import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColumns3Wide"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor"/><Path d="M8.87891 4.5V19.5" stroke="currentColor"/><Path d="M15.1211 4.5V19.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconColumns3Wide;
